<template>
  <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
    <v-list nav>
      <template v-for="(item, index) in items">
        <v-list-item class="mb-n2" v-if="item.heading" :key="item.text">
          <v-list-item-content>
            <v-list-item-title class="title">{{
              item.heading
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2" v-else-if="item.divider" :key="index" />
        <v-list-item class="mt-0 mb-0" v-else :key="item.text" link :to="{ name: item.routeName }" color="primary">
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'Drawer',

  data: () => ({
    items: [
      { heading: "Pomodoro" },
      { icon: 'mdi-chart-bar', text: 'Dashboard', routeName: "pomodoro-review" },
      { divider: true },
      { heading: "Training" },
      { icon: 'mdi-weight-lifter', text: 'Workout', routeName: "training-workout" },
      { icon: 'mdi-calendar-month', text: 'History', routeName: "training-history" },
      { icon: 'mdi-scale-bathroom', text: 'Weight', routeName: "training-weight" },
      { divider: true },
      { heading: "Mood Tracker" },
      { icon: 'mdi-book-open', text: 'Diary', routeName: "mood-diary" },
      { icon: 'mdi-chart-timeline-variant', text: 'Reports', routeName: "mood-reports" },
    ],
  }),

  computed: {
    drawer: {
      get() {
        return this.$store.state.drawer
      },
      set(value) {
        this.$store.commit('toggleDrawer', value)
      }
    }
  }

};
</script>
